import { format, parse } from "date-fns";
import { VARIANT_FORMAT_MAPPING } from "./dateSelectorConstants";
import type { DateVariant } from "./types";

const getFormat = ({ variant }: { variant: DateVariant }) =>
  VARIANT_FORMAT_MAPPING[variant || "day"];

export const getStringValueFromDate = ({
  variant,
  value,
}: {
  variant: DateVariant;
  value?: Date;
}) => {
  if (!value || !(value instanceof Date)) {
    return;
  }

  return format(value, getFormat({ variant }));
};

export const getDateValueFromString = ({
  variant,
  value,
}: {
  variant: DateVariant;
  value: string;
}) => {
  return parse(value, getFormat({ variant }), new Date());
};
